import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, Container, Row, Col, Badge } from 'react-bootstrap';
import { FaUserEdit, FaUserCircle } from 'react-icons/fa';

import { selectProfile } from '../redux/profileSlice';
import FormModal from '../forms/FormModal';
import StudentProfileForm from '../forms/StudentProfileForm';
import FancyButton from '../components/ui/fancyButton';
import './ProfilePage.css';

const ProfilePage = () => {
  const profile = useSelector(selectProfile);
  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  const renderBadges = (arr) => {
    if (!arr || arr.length === 0) return <span className="text-muted">None</span>;
    return arr.map((item, index) => (
      <Badge key={index} pill bg="secondary" className="me-2 mb-1">
        {item}
      </Badge>
    ));
  };

  return (
    <div className="profile-page min-vh-100 d-flex flex-column">
      <main className="flex-fill d-flex justify-content-center align-items-start py-5">
        <Container style={{ maxWidth: '900px' }}>
          {!profile ? (
            <div className="text-center bg-white p-5 rounded shadow-sm">
              <h4>No profile found</h4>
              <p className="text-muted">
                Please complete your profile to personalize your experience.
              </p>
              <FancyButton variant="secondary" onClick={openModal}>
                Complete Profile
              </FancyButton>
            </div>
          ) : (
            <Card className="shadow-sm profile-card">
              <Card.Header className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <FaUserCircle size={48} className="text-primary me-3" />
                  <div>
                    <h5 className="mb-0">{profile.name}</h5>
                    <small className="text-muted">Age: {profile.age}</small>
                  </div>
                </div>
                <FancyButton variant="secondary" size="sm" onClick={openModal}>
                  <FaUserEdit className="me-1" />
                  Edit Profile
                </FancyButton>
              </Card.Header>

              <Card.Body className="px-4 py-3">
                <Row className="mb-3">
                  <Col md={6}>
                    <p>
                      <strong>Education Level:</strong>
                      <br /> {profile.education_level}
                    </p>
                    <p>
                      <strong>Preferred Learning Style:</strong>
                      <br />
                      {profile.preferred_learning_style}
                    </p>
                  </Col>
                  <Col md={6}>
                    <p>
                      <strong>Career Goals:</strong>
                      <br /> {profile.career_goals}
                    </p>
                    <p>
                      <strong>Languages Spoken:</strong>
                      <br /> {renderBadges(profile.languages_spoken)}
                    </p>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <p>
                      <strong>Interests:</strong>
                      <br />
                      {renderBadges(profile.interests)}
                    </p>
                  </Col>
                  <Col md={6}>
                    <p>
                      <strong>Certifications:</strong>
                      <br /> {renderBadges(profile.certifications)}
                    </p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          )}
        </Container>
      </main>

      <FormModal show={showModal} onClose={closeModal} title="Update Profile">
        <StudentProfileForm onClose={closeModal} />
      </FormModal>
    </div>
  );
};

export default ProfilePage;
